module.exports = (
  $rootScope,
  User,
)->
  return {
    restrict: 'A'

    template: require('./document-actions-toolbar.html')

    scope:
      isDisabled:                  '&documentActionsToolbarIsDisabled'
      isStarred:                   '&'
      getStarredDocument:          '&'
      getStarRelevance:            '&'
      newStarredResult:            '&'
      updateStarredDocument:       '&'
      unstar:                      '&'
      openEntityModal:             '&'
      entity:                      '='
      checkDataConciergeAvailable: '&'
      showDataConciergeOrderModal: '&'

    controller: ( $scope ) ->
      $scope.user = User

      $scope.starDocument = ( relevanceType ) ->
        if $scope.isStarred()
          if relevanceType == $scope.getStarRelevance()
            $scope.unstar()
          else
            $scope.changeStarring( relevanceType )
        else
          $scope.newStar( relevanceType )

      $scope.changeStarring = ( relevanceType ) ->
        $scope.getStarredDocument().relevance_type = relevanceType
        $scope.updateStarredDocument()

      $scope.newStar = ( relevanceType ) ->
        $scope.newStarredResult( properties: {
          relevance_type: relevanceType
        })

      $scope.addFactToEntity = () ->
        if not $scope.getStarredDocument()
          $scope.newStar( 'star' )

        $scope.openEntityModal()

      $scope.userCanAddEntities = User.hasPermission('workflow.add_entity', false)
  }

